export default __webpack_public_path__ + "img/shield.6f30dd62.svg";